import { useCallback, useState } from 'react';
import { CouponCode, RedeemSummary } from './List';
import { retrieveRedeem, retrieveRedeemSummary } from 'src/pages/admin/services/whitelistService';

const useRedeem = () => {
  const [records, setRecords] = useState<CouponCode[]>([]);
  const [total, setTotal] = useState(0);
  const [summary, setSummary] = useState<RedeemSummary>();

  const retrieve = useCallback(async (page: number, pageSize: number) => {
    try {
      const response = await retrieveRedeem(page, pageSize);
      
      setRecords(response.data.items.filter((item: any) => item.status === 'active'));
      setTotal(response.data.total || 0);
    } catch (error) {
      console.log('error: ', error);
    }
  }, []);

  const retrieveSummary = useCallback(async () => {
    try {
      const response = await retrieveRedeemSummary();
      setSummary(response.data);
    } catch (error) {
      console.log('error: ', error);
    }
  }, []);

  return {
    retrieve,
    records,
    total,
    retrieveSummary,
    summary,
  };
};

export default useRedeem;
